import { createAction, props } from '@ngrx/store'
import { AiAutoReplyConfigModel, LocationModel, RequestModel, UpgradeAction } from '@models/index'

export const searchAndNavigateToBusinessLocation = createAction(
    '[Locations] Search And Navigate To Business Location',
    props<{ businessId: string, locationId: string }>()
)

export const searchAndNavigateToBusinessLocationComplete = createAction(
    '[Locations] Search And Navigate To Business Location Complete',
)

export const addLocation = createAction(
    '[Locations Page] Add Location',
    props<{ location: LocationModel }>()
)

export const addLocationSuccess = createAction(
    '[Locations Page] Add Location Success',
    props<{ location: LocationModel }>()
)

export const setCurrentLocation = createAction(
    '[Locations Page] Set Current Location',
    props<{ location: LocationModel }>()
)
export const clearCurrentLocation = createAction(
    '[Locations Page] Clear Current Location',
)

export const searchLocations = createAction(
    '[Locations Page] Search Locations',
    props<{ pages: { page: number, size: number } }>()
)

export const searchLocationsSuccess = createAction(
    '[Locations Page] Search Locations Success',
    props<{ page: number, total: number, data: LocationModel[] }>()
)

export const searchLocationsFailed = createAction(
    '[Locations Page] Search Locations Failed'
)

export const searchArchivedLocations = createAction(
    '[Locations Page] Search Archived Locations'
)

export const searchArchivedLocationsSuccess = createAction(
    '[Locations Page] Search Archived Locations Success',
    props<{ ids: string[] }>()
)

export const findLocationById = createAction(
    '[Locations Page] Find Location by Id',
    props<{ locationId: string }>()
)

export const findLocationByIdSuccess = createAction(
    '[Locations Page] Find Location by Id Success',
    props<{ data: LocationModel }>()
)

export const editLocation = createAction(
    '[Locations Page] Edit Location',
    props<{ location: LocationModel }>()
)

export const editLocationMaxQuota = createAction(
    '[Locations Page] Edit Location Max Quota',
    props<{ location: LocationModel }>()
)

export const editLocationSuccess = createAction(
    '[Locations Page] Edit Location Success',
    props<{ location: LocationModel }>()
)

export const deleteLocation = createAction(
    '[Locations Page] Delete Location',
    props<{ locationId: string }>()
)

export const deleteLocationSuccess = createAction(
    '[Locations Page] Delete Location Success',
    props<{ locationIdDeleted: string }>()
)

export const archiveLocation = createAction(
    '[Locations Page] Archive Location',
    props<{ locationId: string }>()
)

export const archiveLocationSuccess = createAction(
    '[Locations Page] Archive Location Success',
    props<{ locationId: string }>()
)

export const searchLocationByQuery = createAction(
    '[Locations Page] Search Location By Query',
    props<{ page: number, size: number, query: string }>()
)

export const getUrls = createAction(
    '[Locations Page] Get URLs',
    props<{ locationId: string }>()
)

export const getUrlsSuccess = createAction(
    '[Locations Page] Get URLs Success',
    props<{ urls: Object[] }>()
)

export const locationError = createAction(
    '[Locations Page] Location Error',
    props<{ error: string }>()
)

export const validateShortName = createAction(
    '[Locations Page] Validate Short Name',
    props<{ request: RequestModel }>()
)

export const validateShortNameSuccess = createAction(
    '[Locations Page] Validate Short Name Success',
    props<{ exist: boolean }>()
)

export const getContactsLast14Days = createAction(
    '[Locations Page] Get Contacts Last 14 Days',
    props<{ request: RequestModel }>()
)

export const getContactsLast14DaysSuccess = createAction(
    '[Locations Page] Get Last 14 Days Contacts count',
    props<{ contactCount: number }>()
)
export const getReviewsLast14Days = createAction(
    '[Locations Page] Get Reviews Last 14 Days',
    props<{ request: RequestModel }>()
)

export const getReviewsLast14DaysSuccess = createAction(
    '[Locations Page] Get Last 14 Days Reviews count }>()',
    props<{ reviewCount: number }>()
)

export const searchLocationByQueryAndLandingUrls = createAction(
    '[Locations Page] Search Location By Query And Landing Urls',
    props<{ page: number, size: number, query: string }>()
)

export const upgradePlan = createAction(
    '[Locations Page] Upgrade plan',
    props<{ payload: { action: UpgradeAction, cancelFeatureButton: string } }>()
)
export const upgradePlanSuccess = createAction(
    '[Locations Page] Upgrade plan Success',
    props<{ location: LocationModel }>()
)

export const enableOrDisableAutoReplyAi = createAction(
    '[Locations Page] Enable Or Disable Auto Reply AI',
    props<{ payload: { locationId: string, data: AiAutoReplyConfigModel } }>()
)
export const enableOrDisableAutoReplyAiSuccess = createAction(
    '[Locations Page] Enable Or Disable Auto Reply AI Success',
    props<{ location: LocationModel }>()
)
